import React from "react";

export const LazyRulesPolicyOwnership = React.lazy(() =>
    import(
        /* webpackChunkName: "PolicyOwnership" */
        "./RulesPolicyOwnership"
    ).then(module => ({ default: module.RulesPolicyOwnership }))
);

export const LazyAddRuleButton = React.lazy(() =>
    import(
        /* webpackChunkName: "LogicRulesPolicyComponents" */
        "./AddRuleButton"
    ).then(module => ({ default: module.AddRuleButton }))
);

export const LazyLogicRulesList = React.lazy(() =>
    import(
        /* webpackChunkName: "LogicRulesPolicyComponents" */
        "./LogicRulesList"
    ).then(module => ({ default: module.LogicRulesList }))
);

export const LazyImportRulesButton = React.lazy(() =>
    import(
        /* webpackChunkName: "LogicRulesPolicyComponents" */
        "./ImportRulesButton"
    ).then(module => ({ default: module.ImportRulesButton }))
);
